module.exports = __webpack_public_path__ + "img/carton.6b25dea3.jpg";